// Kontakformular Pruefungen

if($(".js-submit-taenzersuche").val() == 1){
    $(".js-form-taenzersuche")[0].reset();
    $(".js-form_successblock-taenzersuche").text($(".js-form_submit-taenzersuche").data("success")).fadeIn("slow");
    $(".js-submit-taenzersuche").val(0)
}

$(".js-form_submit-taenzersuche").on('click',function(event){
    event.preventDefault();

    valid = true;

    errorText = $(this).data("error");
    successText = $(this).data("success");
    $(".js-form_successblock-taenzersuche").fadeOut("slow");

    var validSubmit = true;
    var errorCount = 0;

    $.each($(".js-form_input-taenzersuche"), function(key, value){
        var $currentElement = $(this);
        var valid = true;
        var regex = new RegExp($(this).attr("pattern"));
        var $label = $(value).siblings(".js-form_label-taenzersuche");

        // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
        var label_text = $(value).attr("label_text");
        if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $(value).attr("placeholder");

        if($currentElement.val() == "" && $currentElement.attr("required") == "required"){
            $currentElement.attr("title", $currentElement.data("required"));
            valid = false;
            errorCount++;
        }else if(!regex.test($currentElement.val()) && $currentElement.val() != "" && $currentElement.data("format") != ""){
            $currentElement.attr("title", $currentElement.data("format"));
            valid = false;
            errorCount++;
        }else if(!regex.test($currentElement.val()) && $currentElement.val() != ""){
            $currentElement.attr("title", $currentElement.data("max"));
            valid = false;
            errorCount++;
        }else if(typeof $currentElement.data("regex") != "undefined" && $currentElement.val() != ""){
            var regex = new RegExp($currentElement.data("regex"));
            if(regex.test($currentElement.val().replace(/\s/g,''))){
                $currentElement.attr("title", $currentElement.data("error_msg_regex"));
                valid = false;
                errorCount++;
            }
        }else{
            $(this).attr("title", "");
        }


        if(!valid){
            $label.text(label_text + " - " + $(this).attr("title")).addClass("form_label_text-error");
            validSubmit = false;
        }else{
            $label.text(label_text);
            $label.removeClass("form_label_text-error");
        }
    });

    $.each($(".js-form_select-taenzersuche"), function(key, value){
        var valid = true;
        var $label = $(this).siblings(".js-form_label-taenzersuche");

        // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
        var label_text = $(this).attr("label_text");
        if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $(this).attr("placeholder");

        if($(this).val() == null && $(this).attr("required") == "required"){
            $(this).attr("title", $(this).data("required"));
            valid = false;
            errorCount++;
        }

        if(!valid){
            $label.addClass("form_label_text-error");
            $label.text(label_text + " - " + $(this).attr("title"));
            validSubmit = false;

        }else{
            $label.text(label_text);
            $label.removeClass("form_label_text-error");
        }
    });

    if(validSubmit){
        $(".js-form_errorblock-taenzersuche").hide();

        requestData = "";

        $.ajax({
            url:$(this).data("ajax"),
            data:$(".js-form-taenzersuche").serialize(),
            type:"POST"
        }).done(function(errors){
            if(errors == ""){
                if(typeof $(".js-form-taenzersuche")[0] != "undefined"){
                    $(".js-form-taenzersuche").trigger("submit");
                    $(".js-form-taenzersuche")[0].reset();
                }
            }else{
                var errorCount = 0;
                errors = JSON.parse(errors);

                $.each(errors, function(key, value){
                    var $field = $("[name=" + key + "]");
                    var $label = $field.siblings(".js-form_label");

                    // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
                    var label_text = $field.attr("label_text");
                    if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $field.attr("placeholder");

                    $label.addClass("form_label_text-error");
                    $label.text(label_text + " - " + $field.data(value));
                    errorCount++;
                });

                $(".js-form_errorblock-taenzersuche").show();
                $(".js-form_errorblock-taenzersuche").html(errorText.replace('#anz', errorCount));
            }
        });
    }else{
        $(".js-form_errorblock-taenzersuche").show();
        $(".js-form_errorblock-taenzersuche").html(errorText.replace('#anz', errorCount));
    }
});
